module.exports = __webpack_public_path__ + "static/media/paw.226f3aa3.svg";